import { type ReactElement, useCallback } from 'react';

export type AppletFrameProps = {
  applet?: HTMLDivElement;
  overflow?: 'initial' | 'auto';
  height?: '100%' | 'auto';
  contentHeight?: string | null;
  display?: 'block' | 'none';
};

export function AppletFrame({
  applet,
  overflow = 'auto',
  height = '100%',
  contentHeight,
  display = 'block',
}: AppletFrameProps): ReactElement {
  const appendFrame = useCallback(
    (ref: HTMLDivElement | null): void => {
      if (ref && applet) {
        ref.append(applet);
      }
    },
    [applet],
  );

  const effectiveHeight =
    height === 'auto' && contentHeight ? contentHeight : height;

  return (
    <div
      style={{
        display,
        position: 'relative',
        width: '100%',
        height: effectiveHeight,
        overflow,
      }}
      ref={appendFrame}
    />
  );
}
